import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { TableRowSelection } from "antd/es/table/interface";
import { FC, useCallback } from "react";
import "./selectable-list.css";
import { SelectableListItem } from "./selectable-list-item";
export interface SelectableListDataType {
  key: React.Key;
  title: string;
  initials: string;
  timestamp: string;
  progress: string | null | undefined;
  schemaVersion: string;
  caseType: string | null | undefined;
  state: string;
  isArchived?: boolean;
}

interface SelectableListProps {
  data: SelectableListDataType[];
  selectedRecord: SelectableListDataType | undefined;
  onSelectChange: (
    selectedRowKeys: React.Key,
    caseType: string,
    schemaVersion: string
  ) => void;
  isVerticalColumn?: boolean;
}
export const SelectableList: FC<SelectableListProps> = (props) => {
  const onRowChange = (selectedRowKeys: React.Key[]) => {
    if (selectedRowKeys.length === 0) {
      return;
    }
    props.onSelectChange(
      selectedRowKeys[0],
      props.data.find((r) => r.key === selectedRowKeys[0])?.caseType ?? "",
      props.data.find((r) => r.key === selectedRowKeys[0])?.schemaVersion ?? ""
    );
  };

  const rowSelection: TableRowSelection<SelectableListDataType> = {
    selectedRowKeys:
      props.selectedRecord === undefined
        ? []
        : ([props.selectedRecord.key] as React.Key[]),
    onChange: onRowChange,
    type: "radio",
  };
  const columns: ColumnsType<SelectableListDataType> = [
    {
      dataIndex: "name",

      render: (_, record) => (
        <SelectableListItem isVerticalColumn={true} data={record} />
      ),
    },
  ];

  const selectRowCallback = useCallback(
    (record: SelectableListDataType) => {
      props.onSelectChange(
        record.key,
        record.caseType ?? "",
        record.schemaVersion ?? ""
      );
    },
    [props.onSelectChange]
  );

  const selectRow = props.isVerticalColumn
    ? (record: SelectableListDataType) => {
        props.onSelectChange(
          record.key,
          record.caseType ?? "",
          record.schemaVersion ?? ""
        );
      }
    : selectRowCallback;

  return props.isVerticalColumn ? (
    <Table
      onRow={(record) => ({
        onClick: () => {
          selectRow(record);
        },
      })}
      style={{ backgroundColor: "transparent" }}
      rowSelection={rowSelection}
      columns={columns}
      dataSource={props.data}
      className={"selectable-list without-selection-column vertical-column"}
    />
  ) : (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        gap: "10px",
        padding: "10px",
      }}
    >
      {props.data.map((item) => (
        <button
          key={item.key}
          onClick={() => selectRow(item)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              selectRow(item);
            }
          }}
          style={{
            cursor: "pointer",
            background: "none",
            border: "none",
            outline: "none",
            padding: 0,
          }}
        >
          <SelectableListItem data={item} />
        </button>
      ))}
    </div>
  );
};
